<script>
    export let text = "";
</script>

<button>{text}</button>

<style>
    button {
        font-family: inherit;
        font-size: inherit;
        border: none;
        outline: none;
        border-radius: 3px;
        color: white;
        background: var(--primary-color);
        cursor: pointer;
        padding: 10px 20px;
    }
</style>
